// import custom styles and tailwindcss
import "../../styles/components/drawer-cart-custom.css";

/* start free gift code --------------------> */

// global variables
let cart;
let cartPromoEl;
let remainingNoticeEl;
let thresholdReachedEl;
let thresholdValueWrapper;

// threshold value for the promo to trigger -- needs to be in Shopify money format (remove the decimal separator but keep the decimals. e.g. 1234.56 -> 123456)
let thresholdValue = window.cart_promo_item.threshold;

// promo item IDs -- probably should NOT be an array; initially the project scope called for tiered gifts so multiple promo item IDs would have been necessary
let promo_items = [
  window.cart_promo_item.product_id, // mod_pendant
];

// items from the collection which will trigger the promo
let applicableItems = window.cart_promo_item.promo_collection_products;

document.addEventListener("DOMContentLoaded", function () {
  const enabled = window.cart_promo_item.promo_enabled;
  if (enabled) {
    // convenience variable, better named -- copy cart object into variable
    cart = window.CartJS.cart;

    // assign elements for quicker access
    cartPromoEl = document.querySelector("div.cart-promo");
    remainingNoticeEl = document.getElementById("remainingNotice");
    thresholdReachedEl = document.getElementById("thresholdReached");
    thresholdValueWrapper = document.getElementById("promoThresholdRemaining");

    setTimeout(() => {
      init();
    }, 100); // set a small delay to make sure the user is fully loaded and to account for mobile safari being hella slow

    // interestingly this works better via jQuery than it does via a standard vanilla JS event listener
    $(document).on("cart.requestStarted", function (event, cart) {});
    $(document).on("cart.requestComplete", function (event, cart) {
      refreshCartPromo();
      handlePromoItems();
    });
  }
});

// if cart total price value is greater than or equal to [value]
function cartThresholdReached() {
  return cart.total_price >= thresholdValue;
}

// if cart contains any of the items in the promo_items array
function cartContainsPromoItems() {
  return cart.items.some((item) => promo_items.includes(item.product_id));
}

// if cart contains any of the items in the applicableItems array
function cartContainsApplicableItems() {
  return cart.items.some((item) =>
    applicableItems.length && applicableItems.includes(item.handle),
  );
}

function main() {
  // identify which options are set; threshold only, collection only, or both
  const thresholdSet = thresholdValue > 0;
  const collectionSet = applicableItems && applicableItems.length > 0;

  // if the free gift item is already in the cart, hide the promo element entirely
  if (cartContainsPromoItems()) {
    cartPromoEl.classList.add("hidden");
  }

  if (thresholdSet && collectionSet) {
    console.log("this is true");
    // customer only gets a free gift if they buy an item from the specified collection and the cart total is >= the threshold value
    if (cartContainsApplicableItems() && cartThresholdReached()) {
      console.log("this is also true");
      if (!cartContainsPromoItems()) {
        showPromotionNotice(); // show the promotion notice to the customer so they can add the free gift to their cart
      }
    } else if (cartContainsApplicableItems()) {
      // calculate the remaining threshold value and show the message to the customer
      cartThresholdDifference();
      handleThresholdMessaging();
    }
  } else if (thresholdSet) {
    // customer only gets a free gift if the cart total is >= the threshold value
    if (cartThresholdReached()) {
      if (!cartContainsPromoItems()) {
        showPromotionNotice(); // show the promotion notice to the customer so they can add the free gift to their cart
      }
    } else {
      // calculate the remaining threshold value and show the message to the customer
      cartThresholdDifference();
      handleThresholdMessaging();
    }
  } else if (collectionSet) {
    console.log("this is true 2");
    // customer only gets a free gift if any of the items in the cart are from the specified collection
    if (cartContainsApplicableItems()) {
      console.log("this is also true 2");
      if (!cartContainsPromoItems()) {
        showPromotionNotice(); // show the promotion notice to the customer so they can add the free gift to their cart
      }
    }
  }
}

// initialize the logic on first page load
function init() {
  if (cart.items.length > 0) {
    main();
    handlePromoItems();
  }
}

// shows the notice detailing how much money is left to reach the promotion's threshold for a gift
function handleThresholdMessaging() {
  cartPromoEl.classList.remove("hidden");
  remainingNoticeEl.classList.remove("hidden");
  thresholdReachedEl.classList.add("hidden");
}

// shows the notice that the threshold or condition has been reached and offers a ATC button for moving the item into the cart
function showPromotionNotice() {
  cartPromoEl.classList.remove("hidden");
  remainingNoticeEl.classList.add("hidden");
  thresholdReachedEl.classList.remove("hidden");
}

// handlePromoItems is a helper function
// it scans the cart, if any of the promo items are in the cart, then it finds the item in the cart HTML and adds a class to it
// -- useful for hiding the QTY selector
function handlePromoItems() {
  // first reset the classes, seems like there is a bug with rivets.js (used by CartJS) that swaps an item for another after a remove event and keeps classes from old item around
  document
    .querySelectorAll(".is-promo-item")
    .forEach((item) => item.classList.remove("is-promo-item"));

  if (cartContainsPromoItems()) {
    promo_items.forEach((item) => {
      document
        .querySelector("div.js-minicart-item[data-product-id='" + item + "']")
        .classList.add("is-promo-item");
    });
  }
}

// handles formatting money into a proper human-readable display format
function formatMoney(value) {
  const formattedPrice = new Intl.NumberFormat("en-EN", {
    style: "currency",
    currency: window.Shopify.currency.active,
    trailingZeroDisplay: "stripIfInteger",
  }).format(value);
  return formattedPrice;
}

// calculates the difference between the threshold and the cart's total price
function cartThresholdDifference() {
  thresholdValueWrapper.innerText =
    cart.total_price >= thresholdValue
      ? "$0"
      : formatMoney((thresholdValue - window.CartJS.cart.total_price) / 100);
}

// whenever the cart is updated, this function will be called and will handle the logic to show/hide the notice
function refreshCartPromo() {
  if (cart.items.length > 0) {
    main();
  } else {
    cartPromoEl.classList.add("hidden");
  }
}

/* end free gift code ----------------------> */
